import React, { useCallback, useEffect, useState } from "react";

import { SideBars } from "../../../global";

import { SearchAnyForm } from "./SearchAnyForm";
import { useSearchAnySideBar } from "../../../../shared/hooks/useSideBar";
import { LayersApiService } from "../../../../shared/services/api/layers-api.service";

export const SearchAnySideBar: React.FC = () => {
    const { setShouldOpen, shouldOpen } = useSearchAnySideBar();
    const [layersLabel, setLayersLabel] = useState<Record<string, string>>();

    const fetchLayersLabel = useCallback(async () => {
        const layers = await LayersApiService.getLayers(
            `where={"cam_ativa_webgeo":"true"}&`
        );

        const labels = layers.data.reduce(
            (acc, layer) => {
                // Verifica se cam_desc_webgeo NÃO contém "ortofoto" (case insensitive)
                if (!/ortofoto/i.test(layer.cam_desc_webgeo)) {
                    acc[layer.cam_nome_geoserver] = layer.cam_desc_webgeo;
                }
                return acc;
            },
            {} as Record<string, string>
        );
        setLayersLabel(labels);
    }, []);

    useEffect(() => {
        fetchLayersLabel();
    }, [fetchLayersLabel]);

    const RenderAnySearchForm = useCallback(() => {
        if (layersLabel) return <SearchAnyForm possibilites={layersLabel} />;

        return <p>Nenhum campo de pesquisa encontrado.</p>;
    }, [layersLabel]);

    return (
        <SideBars
            orientation="right"
            handleClose={() => setShouldOpen(false)}
            show={shouldOpen}
        >
            <RenderAnySearchForm />
        </SideBars>
    );
};
